module.exports = __webpack_public_path__ + "img/Bear18.2d470f02.jpg";